import React from "react";
import { compose } from 'recompose';
import { connect } from 'react-redux';
import * as types from 'src/types';
import * as model from '../../data/model';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Checkbox from "@material-ui/core/Checkbox";
let moment = require('moment')
import RefreshIcon from "@material-ui/icons/Refresh"
import * as track from '../../data/track/track';
// material-ui icons
import MicIcon from "@material-ui/icons/Mic";
import SubscribeIcon from "@material-ui/icons/Subscriptions"
import EditIcon from "@material-ui/icons/Edit"
import PodCastStatus from "./PodCastStatus"
// core components
import AddIcon from "@material-ui/icons/Add";
import GridContainer from "src/components/Grid/GridContainer.jsx";
import GridItem from "src/components/Grid/GridItem.jsx";
import Table from "../../components/Table/Table";
import TableHead from "@material-ui/core/TableHead";
import CustomTable from "src/components/Table/Table.jsx";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Button from "src/components/CustomButtons/Button.jsx";
//import Button from "src/components/CustomButtons/Button.jsx";
import Card from "src/components/Card/Card.jsx";
import CardBody from "src/components/Card/CardBody.jsx";
import CardIcon from "src/components/Card/CardIcon.jsx";
import CardHeader from "src/components/Card/CardHeader.jsx";
import SubscribeDialog from "./SubscribeDialog"
//import extendedTablesStyle from "src/assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";

import product1 from "src/assets/img/product1.jpg";
import product2 from "src/assets/img/product2.jpg";
import product3 from "src/assets/img/product3.jpg";
import PodCastTypeDialog from "./PodCastTypeDialog"
import buttonGroupStyle from "src/assets/jss/material-dashboard-pro-react/buttonGroupStyle.jsx";
import customCheckboxRadioSwitch from "src/assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import { cardTitle } from "src/assets/jss/material-dashboard-pro-react.jsx";
import { TableBody } from "@material-ui/core";
import AddTrackIcon from "@material-ui/icons/Add"
const extendedTablesStyle = {
    ...customCheckboxRadioSwitch,
    ...buttonGroupStyle,
    right: {
        textAlign: "right"
    },
    center: {
        textAlign: "center"
    },
    description: {
        maxWidth: "150px"
    },
    actionButton: {
        margin: "0 0 0 5px",
        padding: "5px",
        "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
            marginRight: "0px"
        }
    },
    icon: {
        verticalAlign: "middle",
        width: "17px",
        height: "17px",
        top: "-1px",
        position: "relative"
    },
    imgContainer: {
        width: "120px",
        maxHeight: "160px",
        overflow: "hidden",
        display: "block"
    },
    img: {
        width: "100%",
        height: "auto",
        verticalAlign: "middle",
        border: "0"
    },
    tdName: {
        minWidth: "200px",
        fontWeight: "400",
        fontSize: "1.5em"
    },
    tdNameAnchor: {
        color: "#3C4858"
    },
    tdNameSmall: {
        color: "#999999",
        fontSize: "0.75em",
        fontWeight: "300"
    },
    tdNumber: {
        textAlign: "right",
        minWidth: "145px",
        fontWeight: "300",
        fontSize: "1.3em !important"
    },
    tdNumberSmall: {
        marginRight: "3px"
    },
    tdNumberAndButtonGroup: {
        lineHeight: "1 !important"
    },
    positionAbsolute: {
        position: "absolute",
        right: "0",
        top: "0"
    },
    customFont: {
        fontSize: "16px !important"
    },
    actionButtonRound: {
        width: "auto",
        height: "auto",
        minWidth: "auto"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    }
};

interface PodCastListProps {
    connect: types.IState;
    classes: any;
}
interface PodCastListState {
    subscribeOpen: boolean;
    subscribePodcastId: any;
    podcastTypeDialog: boolean;
}

class PodCastList extends React.Component<PodCastListProps, PodCastListState> {
    constructor(props: PodCastListProps) {
        super(props);
        this.state = {
            subscribeOpen: false,
            subscribePodcastId: undefined,
            podcastTypeDialog: (props.connect.lo_PodCasts.val().length == 0)
        };

    }

    render() {
        const { classes } = this.props;
        /*
        const fillButtons = [
          { color: "info", icon: Person },
          { color: "success", icon: Edit },
          { color: "danger", icon: Close }
        ].map((prop, key) => {
          return (
            <Button color={prop.color} className={classes.actionButton} key={key}>
              <prop.icon className={classes.icon} />
            </Button>
          );
        });
        const simpleButtons = [
          { color: "info", icon: Person },
          { color: "success", icon: Edit },
          { color: "danger", icon: Close }
        ].map((prop, key) => {
          return (
            <Button
              color={prop.color}
              simple
              className={classes.actionButton}
              key={key}
            >
              <prop.icon className={classes.icon} />
            </Button>
          );
        });
    
        const roundButtons = [
          { color: "info", icon: Person },
          { color: "success", icon: Edit },
          { color: "danger", icon: Close }
        ].map((prop, key) => {
          return (
            <Button
              round
              color={prop.color}
              className={classes.actionButton + " " + classes.actionButtonRound}
              key={key}
            >
              <prop.icon className={classes.icon} />
            </Button>
          );
        });*/
        let me = this;
        let tableData = [];

        if (this.props.connect.lo_PodCasts.completed()) {
            tableData = this.props.connect.lo_PodCasts.val().map(p => {
                let tracks = this.props.connect.lo_Tracks.val().filter(t => t.podcast_id == p.id).sort((a: model.Track, b: model.Track) => {
                    return a.created > b.created ? 1 : -1
                })

                return [
                    (<img src={p.image_url} height={30} width={30} />),
                    p.title,
                    (<Button style={{
                        color: 'black',
                        textDecoration: 'underline'
                    }} simple color='default' className={classes.actionButton} onClick={(e) => {
                        types.ViewState.navigate(types.ViewState.hashPodCastView(p.id))
                        e.stopPropagation();
                        return false;
                    }} >{tracks.length + ' tracks'}</Button>),
                    tracks.length > 0 ? moment(tracks[0].created).calendar() : "",
                    (<PodCastStatus podcast={p} />),
                    [
                        (
                            <Button simple color="info" className={classes.actionButton} onClick={(e) => {
                                //types.ViewState.navigate(types.ViewState.hashPodCastView(p.id))
                                types.ViewState.navigate(types.ViewState.hashPodCastEdit(p.id))
                                e.stopPropagation();
                                return false;
                            }} >
                                <EditIcon />Edit
                            </Button>),
                        (<Button simple color="primary" className={classes.actionButton} onClick={(e) => {
                            let s = { ...me.state };
                            s.subscribeOpen = true;
                            s.subscribePodcastId = p.id;

                            me.setState(s)
                            e.stopPropagation();
                            return false;
                        }}> <SubscribeIcon /> Subscribe</Button>),
                        (
                            <span>
                                {p.podcast_type == model.PodCastType.adhoc &&
                                    <Button simple color="success" className={classes.actionButton} onClick={(e) => {

                                        types.ViewState.navigate(types.ViewState.hashTrackCreate(p.id))
                                        e.stopPropagation();
                                        return false;
                                    }} >
                                        <AddTrackIcon /> Add Track
                            </Button>
                                }
                                {p.podcast_type == model.PodCastType.rss &&
                                    <Button simple color="success" className={classes.actionButton}
                                        disabled={p.feed_status != model.PodCastFeedStatus.ready}
                                        onClick={ (e) => {
                                            e.stopPropagation();
                                           
                                             this.props.connect.lo_ctx.val().PodCast.sync(p.id);
                                            return false;
                                            //types.ViewState.navigate(types.ViewState.hashTrackCreate(podcast.id))
                                        }}>
                                        <RefreshIcon className={classes.icons} /> Refresh

</Button>

                                }
                            </span>)
                    ]
                ]
            });

        }

        return (
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={3}>
                                    <CardIcon color="rose">
                                        <MicIcon />
                                    </CardIcon>
                                    <h4 className={classes.cardIconTitle}>PodCasts</h4>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={9}>
                                    <div style={{ float: 'right' }}>
                                        <Button color='success' simple onClick={(e) => {
                                            let s = { ...me.state };
                                            s.podcastTypeDialog = true;
                                            me.setState(s);
                                            //  types.ViewState.navigate(types.ViewState.hashPodCastEdit('new'))
                                        }} >
                                            <AddIcon className={classes.icons} /> New PodCast
          </Button>
                                    </div>

                                </GridItem>
                            </GridContainer>
                        </CardHeader>
                        <CardBody>

                            {this.props.connect.lo_PodCasts.notLoaded() && (

                                <img src='/loading.gif' />

                            )}
                            {this.props.connect.lo_PodCasts.loading() && (

                                <img src='/loading.gif' />

                            )}
                            <Table
                                loading={this.props.connect.lo_PodCasts.completed()}
                                tableHead={['', 'Name', 'Tracks', 'Last Published','Status']}
                                tableData={tableData}
                                hover
                                onRowClick={(prop: any) => {

                                    let pc = me.props.connect.lo_PodCasts.val()[prop.key]
                                    types.ViewState.navigate(types.ViewState.hashPodCastView(pc.id))
                                }}
                            />


                        </CardBody>
                    </Card>
                </GridItem>
                <SubscribeDialog
                    open={this.state.subscribeOpen}
                    podcast_id={this.state.subscribePodcastId}
                    close={() => {
                        let s = { ...me.state };
                        s.subscribeOpen = false;
                        me.setState(s)
                    }} />
                <PodCastTypeDialog
                    open={this.state.podcastTypeDialog}
                    close={() => {
                        let s = { ...me.state };
                        s.podcastTypeDialog = false;
                        me.setState(s)
                    }} />
            </GridContainer>
        );
    }
}


export function mapStateToProps(state: types.IState) {
    //@ts-ignore
    //withStyles(extendedTablesStyle)(ExtendedTables),
    return {
        connect: state
    }
}
export default compose(

    withStyles(extendedTablesStyle as any),
    connect(mapStateToProps, null)
)(PodCastList);





// WEBPACK FOOTER //
// ./src/views/podcast/PodCastList.tsx